// 导入封装的方法
import {
  post
} from '../http'

const CallForProposals = {
  add (params) {
    return post('/submission/clue/appAdd', params)
  }
}
export default CallForProposals
